import { AppState } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setAppBasketUrlReducer = (state: AppState, action: PayloadAction<string | undefined>) => {
  state.basketUrl = action.payload;
};

export default setAppBasketUrlReducer;
